import { bg_image } from "../../Utils/export";

const HeroSection = () => (
  <section
    className="relative  bg-cover bg-center text-white h-[500px] flex items-center justify-center"
    style={{ backgroundImage: `url(${"https://i.pinimg.com/736x/2d/13/e1/2d13e1af56232f45b63d52d50d22d29d.jpg"})` }}
  >
    <div className="bg-black/50 w-full h-full absolute top-0 left-0" />
    <div className="relative z-10 text-center px-4">
      <h1
        className="text-4xl md:text-5xl font-bold mb-4"
        data-aos="fade-up"
        data-aos-duration="800"
      >Your Real Estate Journey Starts Here.</h1>
      <p
        className="text-xl mb-6"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-delay="200"
      >Everything from buying & selling to home services – all in one place.</p>
      <button
        className="px-6 py-3 bg-gradient-to-r from-indigo-500 to-emerald-500 text-white rounded-full shadow-lg hover:opacity-90 transition"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-delay="400"

      >
        Explore Our Services
      </button>
    </div>
  </section>
);

export default HeroSection;
